import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceDocumentNodeFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-document-node-fragment';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const updateSurfaceDocumentNodeMutation = gql`
  mutation updateSurfaceDocumentNode($input: UpdateSurfaceDocumentNodeInput!) {
    updateSurfaceDocumentNode(input: $input) {
      success
      error
      data {
        ...surfaceNodeUnionDetails
      }
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(updateSurfaceDocumentNodeMutation);
